import api from './api';
import { Bid, CreateBidDTO, AcceptBidResponse } from '../types/bid';

export const bidService = {
  createBid: async (bidData: CreateBidDTO) => {
    try {
      console.log('Creating bid with data:', bidData);
      const response = await api.post<Bid>('/api/v1/bids', bidData);
      console.log('Bid created successfully:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('Error creating bid:', error.response?.data || error.message);
      throw error;
    }
  },

  getMyBids: async () => {
    try {
      console.log('Fetching my bids...');
      const response = await api.get<Bid[]>('/api/v1/bids');
      console.log('Raw API response:', response);
      console.log('Bids data structure:', JSON.stringify(response.data, null, 2));
      console.log('Bids fetched successfully:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('Error fetching bids:', error.response?.data || error.message);
      throw error;
    }
  },

  getBidsByTaskId: async (taskId: number) => {
    try {
      console.log('Fetching bids for task:', taskId);
      const response = await api.get<Bid[]>(`/api/v1/bids?task_id=${taskId}`);
      console.log('Task bids fetched successfully:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('Error fetching task bids:', error.response?.data || error.message);
      throw error;
    }
  },

  getBidById: async (bidId: number) => {
    try {
      console.log('Fetching bid:', bidId);
      const response = await api.get<Bid>(`/api/v1/bids/${bidId}`);
      console.log('Bid fetched successfully:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('Error fetching bid:', error.response?.data || error.message);
      throw error;
    }
  },

  updateBid: async (bidId: number, bidData: Partial<Bid>) => {
    try {
      console.log('Updating bid:', bidId, 'with data:', bidData);
      const response = await api.put<Bid>(`/api/v1/bids/${bidId}`, bidData);
      console.log('Bid updated successfully:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('Error updating bid:', error.response?.data || error.message);
      throw error;
    }
  },

  acceptBid: async (bidId: number): Promise<AcceptBidResponse> => {
    try {
      console.log(`Опитвам да приема оферта с ID: ${bidId}`);
      
      // Първо проверяваме статуса на офертата
      const bid = await api.get<Bid>(`/api/v1/bids/${bidId}`);
      if (bid.data.status !== 'pending') {
        throw new Error('Офертата вече не е активна');
      }
      
      const response = await api.post<AcceptBidResponse>(`/api/v1/bids/${bidId}/accept`);
      console.log(`Успешно приета оферта:`, response.data);
      return response.data;
    } catch (error: any) {
      console.error(`Грешка при приемане на оферта ${bidId}:`, error);
      if (error.response) {
        console.error(`Статус код: ${error.response.status}`);
        console.error(`Съобщение за грешка:`, error.response.data);
        throw new Error(error.response.data.detail || 'Възникна грешка при приемане на офертата');
      }
      throw new Error(error.message || 'Възникна проблем с връзката към сървъра');
    }
  },

  deleteBid: async (bidId: number) => {
    try {
      console.log('Deleting bid:', bidId);
      const response = await api.delete<Bid>(`/api/v1/bids/${bidId}`);
      console.log('Bid deleted successfully:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('Error deleting bid:', error.response?.data || error.message);
      throw error;
    }
  }
}; 